import { getQuizTestReport } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';

const useQuizTestReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState();

	const isLoading = hasUnfilledRequest(getQuizTestReport);

	const fetchQuizTestReportData = async (
		browserPersonDayFrom,
		browserPersonDayTo,
		domain,
		test,
		compareSource,
		compareTo,
	) => {
		const payload = {
			browserPersonDayFrom,
			browserPersonDayTo,
			domain,
			test,
			compareSource,
			compareTo,
		};

		const response = await makeRequest(getQuizTestReport.bind(null, payload));

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}
		setData(response.data);
	};

	return {
		fetchQuizTestReportData,
		isLoading,
		data,
	};
};

export default useQuizTestReport;
